import { Component, Input } from '@angular/core';
import * as _ from 'lodash';


@Component({
  moduleId: module.id,
  selector: 'score-component',
  templateUrl: 'score.component.html',
  styleUrls: ['score.component.scss'],
})
export class ScoreComponent {
  @Input() score: any;

  get hasScore(): boolean {
    return !_.isNil(this.score);
  }

  get validLevel(): string {
    if (!this.hasScore) {
      return 'percentage-black';
    } else if (this.score < 75) {
      return 'percentage-red';
    } else if (this.score >= 75 && this.score <= 99) {
      return 'percentage-black';
    } else {
      return 'percentage-green';
    }
  }
}
